import { Component } from '@angular/core'
import { Emittable, Emitter } from '@ngxs-labs/emitter'
import { PlugplayState } from '../../states/plugplay-state.service'

@Component({
  selector: 'app-step8',
  templateUrl: './step8.component.html',
  styleUrls: ['./step8.component.scss'],
})
export class Step8Component {
  @Emitter(PlugplayState.setActive)
  private readonly setActive: Emittable<number>
  @Emitter(PlugplayState.setHighestLastStepCompleted)
  public readonly setHighestLastStepCompleted: Emittable<number>
  @Emitter(PlugplayState.setHighestStepVisited)
  private readonly setHighestStepVisited: Emittable<number>
  constructor() {
    this.setHighestLastStepCompleted.emit(7)
    this.setActive.emit(7)
    this.setHighestStepVisited.emit(7)
  }
}
